import { createContext, type ReactNode, useContext } from "react";

interface PlatformContextType {
  logout: () => void;
}

const PlatformContext = createContext<PlatformContextType | null>(null);

interface PlatformProviderProps {
  children: ReactNode;
  logout: () => void;
}

export function PlatformProvider({
  children,
  logout,
}: Readonly<PlatformProviderProps>) {
  return (
    <PlatformContext.Provider value={{ logout }}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform(): PlatformContextType {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error("usePlatform must be used within a PlatformProvider");
  }
  return context;
}
